import { create } from 'zustand'

// note: report issue modal can be opened in different locations, scope defines the source/origin location.

type Scope = 'copilot.chat' | 'agent.execute' | undefined

type ReportIssueModalStore = {
  scope: Scope
  isOpen: boolean
  setClose: () => void
  setOpen: (scope: Scope) => void
}

export const useReportIssueModal = create<ReportIssueModalStore>((set) => ({
  isOpen: false,
  scope: undefined,
  setClose: () => set({ isOpen: false, scope: undefined }),
  setOpen: (scope: Scope) => set({ isOpen: true, scope }),
}))
